const $page = $('#page');

module.exports = {
    toggleEvent: 'dp-toggle-waiting-page',
    bindVisibility() {
        $page
            .off(this.toggleEvent)
            .on(this.toggleEvent, this.onToggleVisibility);
    },
    triggerVisibility(isShow = false) {
        $page.trigger(this.toggleEvent, isShow);
    },
    onToggleVisibility: function(event, isShow) {
        $(this).attr('data-waiting', function() {
            return isShow || null;
        });
        if (!isShow) {
            Odigeo.trigger('checkLazyImages');
        }
    },
};
